export class Endereco {
  ativo: boolean;
  id: number;
  bairro: string;
  cep: string;
  cidadeId: number;
  complemento: string;
  logradouro: string;
  numero: string;
  tipoLogradouroId: number;
  coordenadaLatitude: number;
  coordenadaLongitude: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/shared/endereco.model.ts
 **/